import { BrowserServicesOrchestrator } from "./browser-services-orchestrator";
import type { EnvConfig } from "./env";
import type { Credentials, Environments, Urls } from "./types";

export type { Environments, Urls } from "./types";

export type BaseConfigOverrides = Partial<EnvConfig>;

type ServiceOrchestratorConfig = {
	env: EnvConfig;
};

export class ServicesOrchestrator {
	private readonly envConfig: EnvConfig;
	private readonly browserServices: BrowserServicesOrchestrator;

	constructor(config: ServiceOrchestratorConfig) {
		this.envConfig = config.env;
		this.browserServices = new BrowserServicesOrchestrator({ env: config.env });
	}

	private getOptionalServerEnv(key: keyof EnvConfig): string {
		const value = (this.envConfig as Partial<EnvConfig>)[key];
		return typeof value === "string" ? value : "";
	}

	get environment(): Environments {
		return this.browserServices.environment;
	}

	get isProduction(): boolean {
		return this.browserServices.isProduction;
	}

	get isUat(): boolean {
		return this.browserServices.isUat;
	}

	get isDevelopment(): boolean {
		return this.browserServices.isDevelopment;
	}

	get urls(): Urls {
		return this.browserServices.urls;
	}

	get credentials(): Credentials {
		return {
			axiom: {
				token: this.getOptionalServerEnv("COMMON_ENV_AXIOM_TOKEN"),
				orgId: this.getOptionalServerEnv("COMMON_ENV_AXIOM_ORG_ID"),
				dataset: this.getOptionalServerEnv("COMMON_ENV_AXIOM_DATASET"),
			},
			...this.browserServices.credentials,
		};
	}
}
